<template>
  <div class="pros-module">
    <div class="main-content">
      <div class="header">
        <span class="title">打通私域直播全流程，为您的业务增长提速</span>
        <div class="swipper">
          <div
            class="pro-item"
            v-for="(str, i) in pros"
            :key="i"
            @click="selected = i"
            @mouseover="selected = i"
          >
            <span
              class="pro-text"
              :class="selected == i ? 'selected-text' : ''"
              >{{ str }}</span
            >
            <div
              :class="selected == i ? 'isShow' : 'isNotShow'"
              class="pro-selected"
            ></div>
          </div>
        </div>
      </div>
      <div class="pros-body">
        <div class="pro-detail-item">
          <div class="item-img-box margin-right">
            <img :src="prosDetailList[selected].img" alt="" />
          </div>
          <div class="item-text-box">
            <div class="text-title">{{ prosDetailList[selected].title }}</div>
            <div class="text-contents">
              <div
                class="content-item"
                v-for="(newStr, k) in prosDetailList[selected].contents"
                :key="k"
              >
                <div class="grey-point"></div>
                <div class="text">{{ newStr }}</div>
              </div>
            </div>
            <div class="text-button">免费试用</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "prosModule",
  data() {
    return {
      pros: ["方便快捷", "分享裂变", "用户留存", "加速变现", "数据分析"],
      selected: 0,
      prosDetailList: [
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-1.png",
          title: "方便快捷",
          contents: [
            "无需开发，开箱即用，一天上线，PC、手机、微信端等全终端覆盖",
            "操作界面直观、一键嵌入自有公众号、门户、小程序、APP，快速上手，一天即会",
            "支持PC网页、APP、OBS推流等近10种直播方式，一键开播，无需下载任何插件",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-2.png",
          title: "分享裂变",
          contents: [
            "支持推流分享至视频号、微博、抖音、B站等各大主流平台播放，实现裂变式引流",
            "支持通过微信、公众号、短信等渠道触达用户，激活企业私域流量",
            "支持使用邀请卡、分享有礼等功能促进用户分享直播，达成私域自裂变",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-3.png",
          title: "用户留存",
          contents: [
            "互动聊天、红包抽奖、点赞送礼等多种营销功能，活跃直播间气氛，提高用户参与度",
            "在线问答、匿名聊天、客服私聊，鼓励用户参与讨论并实时回复，提升参与价值感",
            "支持网页、移动、APP等多终端直播观看，提高用户便利性与体验感，增加用户留存",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-4.png",
          title: "加速变现",
          contents: [
            "支持竖屏直播，迎合用户观看习惯，沉浸式体验",
            "直播间可对接企业自有商城，上架推送商品卡片，观众边看边买，加快购买决策",
            "支持多样化的直播形式，可通过产品演示、知识培训的方式吸引用户，引导购买",
          ],
        },
        {
          img: "https://www-static.qbox.me/sem/pili-live-1001/source/img/pro-5.png",
          title: "数据分析",
          contents: [
            "多维度用户画像、直播观看统计，帮助企业复盘直播效果",
            "精细化的数据报告，帮助企业快速了解观众画像，实现精准转化",
            "开放标准接口，可与企业自有体系打通，实现多平台、全链路数据同步",
          ],
        },
      ],
    };
  },
};
</script>
<style>
.isShow {
  opacity: 1;
  z-index: 2;
  /* transition: width 0s .1s,opacity .1s .1s ; */
  /* transform: translateY(0); */
  transition: all 0.35s;
}
.isNotShow {
  opacity: 0;
  z-index: 0;
  /* transition: all .3s; */
}
</style>
<style lang="scss" scoped>
.pros-module {
  background: #f8f9fe;
  width: 100%;
  height: 750px;
  min-width: 1440px;
  display: flex;
  padding: 80px 0;
  .main-content {
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .header {
      width: 100%;
      height: 143px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      .title {
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 48px;
        letter-spacing: 0px;
      }
      .swipper {
        width: 616px;
        height: 44px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        .pro-item {
          height: 44px;
          font-family: PingFang SC;
          font-size: 18px;
          font-weight: 500;
          line-height: 25px;
          letter-spacing: 0px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          transition: all 0.3s ease;
          .selected-text {
            color: #ff650e;
            transition: all 0.3s ease;
          }
          .pro-selected {
            height: 3px;
            width: 40px;
            border-radius: 2px;
            background: #ff650e;
          }
        }
      }
    }
    .pros-body {
      width: 100%;
      padding-top: 32px;
      height: 570px;
      display: flex;
      position: relative;
      .pro-detail-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item-img-box {
          height: 100%;
          display: flex;
          img {
            margin: auto;
            transition: opacity 1s;
          }
        }
        .item-text-box {
          transition: opacity 1s;
          display: flex;
          flex-direction: column;
          color: #333333;
          align-items: flex-start;
          font-family: PingFang SC;
          letter-spacing: 0em;
          text-align: left;

          .text-title {
            margin-bottom: 24px;
            font-size: 32px;
            font-weight: 500;
            line-height: 48px;
          }

          .text-contents {
            margin-bottom: 26px;
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            .content-item {
              display: flex;
              flex-direction: row;
              margin-bottom: 24px;
              .grey-point {
                width: 8px;
                height: 8px;
                margin: auto 0;
                background: #c7cede;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
          }
          .text-button {
            cursor: pointer;
            position: relative;
            animation: pulse 2s infinite;
            width: 148px;
            height: 48px;
            border-radius: 26px;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 600;
            line-height: 48px;
            letter-spacing: 0em;
            text-align: center;
            background: linear-gradient(251.22deg, #2dabff 0%, #1472ff 100%);
            color: #fff;
            &:hover {
              transform: scale(1.05);
              transition: 0.3s ease-in-out;
              animation: none;
              box-shadow: 0 8px 32px rgba(45, 147, 230, 0.521);
            }
          }
          @keyframes pulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 8px 32px rgba(45, 147, 230, 0.521);
            }
            100% {
              transform: scale(1);
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .main-content {
      width: 1180px;
      .header {
        .title {
          font-size: 36px;
        }
      }
      .margin-right {
        margin-right: 68px;
      }
      .item-img-box {
        width: 626px;
        img {
          margin: auto;
          width: 626px;
          height: 524.74px;
        }
      }
      .text-contents{
        height: 204px;
      }
    }
  }
  @media screen and (min-width: 1441px) {
    .main-content {
      width: 1420px;
      .header {
        .title {
          font-size: 40px;
        }
      }
      .margin-right {
        margin-right: 132px;
      }
      .item-img-box {
        width: 680px;
        img {
          margin: auto;
          width: 680px;
          height: 570px;
        }
      }
    }
  }
}
</style>